var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex w-16 h-8 mx-auto justify-between items-center"},_vm._l((_vm.dots),function(d){return _c('div',{key:d.index,class:("dot " + _vm.bgColor + " rounded-full")})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }